module.exports = __webpack_public_path__ + "res/roboto-v15-latin-500.woff2";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-500.woff2
// module id = 100
// module chunks = 1